import moment from 'moment';

/* eslint-disable no-mixed-operators */
const getUrlArgs = function () {
  const urlAgrs = {};
  location.href.split('?')[1] && location.href.split('?')[1].split('&').map((item) => {
    urlAgrs[item.split('=')[0]] = decodeURIComponent(item.split('=')[1]);
  });
  return urlAgrs;
};

const downloadFile = (loadUrl) => {
  const formEle = document.createElement('form');
  formEle.setAttribute('method', 'get');
  formEle.setAttribute('action', loadUrl);
  document.body.appendChild(formEle);
  formEle.submit();
  setTimeout(() => {
    formEle.remove();
  }, 100);
};

const getBeforeDate = num => new Date(+new Date() - 3600 * 24 * num * 1000);

const dateFormat = (date, fmt) => {
  const dateObj = date;
  const o = {
    'M+': dateObj.getMonth() + 1, // 月份
    'd+': dateObj.getDate(), // 日
    'h+': dateObj.getHours(), // 小时
    'm+': dateObj.getMinutes(), // 分
    's+': dateObj.getSeconds(), // 秒
    'q+': Math.floor((dateObj.getMonth() + 3) / 3), // 季度
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (dateObj.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
      }
  }
  return fmt;
};

const getUrlSearch = (name) => {
  if (!name) return null;
  let after = window.location.search;
  after = after.substr(1) || window.location.hash.split('?')[1];
  if (!after) return null;
  if (after.indexOf(name) === -1) return null;
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = decodeURI(after).match(reg);
  if (!r) return null;
  return r[2];
};

const install = {
  /* eslint-disable func-names */
  install (Vue) {
    /**
     * 固定页面视口
     * @param {Boolean} isFixed true/false 不传则自动交替
     */
    Vue.prototype.$toggleFrame = function (isFixed) {
      const style = 'position: fixed; left: 0; right: 0; overflow: hidden';
      // 自定义
      if (typeof isFixed === 'boolean') {
        document.body.style.cssText = isFixed ? style : '';
      } else {
        document.body.style.overflow === 'hidden' ? document.body.style.cssText = '' : document.body.style.cssText = style;
      }
    };
  },
};


/**
 * 倒计时
 * id 标识
 * endDateStr 结束时间
 * nowDateStr 服务器时间
 * cb 回调
 */
const CountTimer = {};
const CountDownTime = (id, endDateStr, nowDateStr, cb) => {
  const endDate = new Date(`${endDateStr}`.replace(/-/g, '/'));
  const nowDate = nowDateStr ? new Date(`${nowDateStr}`.replace(/-/g, '/')) : new Date();
  // 总秒数
  // eslint-disable-next-line radix
  const totalSeconds = Math.floor((endDate.getTime() - nowDate.getTime()) / 1000);
  if (totalSeconds < 0) return;
  const d = Math.floor(totalSeconds / (60 * 60 * 24));
  // eslint-disable-next-line no-mixed-operators
  const h = Math.floor(totalSeconds % (60 * 60 * 24) / (60 * 60));
  const m = Math.floor(totalSeconds % (60 * 60 * 24) % (60 * 60) / 60);
  const s = Math.floor(totalSeconds % (60 * 60 * 24) % (60 * 60) % 60);
  const timeObj = { d, h, m, s }; const time = {};
  Object.keys(timeObj).map((key) => {
    // eslint-disable-next-line radix
    const ten = Math.floor(timeObj[key] / 10 || 0);
    // eslint-disable-next-line radix
    const bit = Math.floor(timeObj[key] % 10 || 0);
    time[key] = [Math.max(ten, 0), Math.max(bit, 0)];
  });
  cb(time, totalSeconds === 0);
  if (CountTimer[id]) clearInterval(CountTimer[id]);
  CountTimer[id] = setInterval(() => {
    const nowTemp = nowDate.getTime() + 1000;
    // console.log('tag---', moment(nowTemp).format('YYYY-MM-DD HH:mm:ss'));
    CountDownTime(id, endDateStr, moment(nowTemp).format('YYYY-MM-DD HH:mm:ss'), cb);
  }, 1000);
};

export default {
  getUrlArgs,
  downloadFile,
  getBeforeDate,
  dateFormat,
  getUrlSearch,
  install,
  CountDownTime,
};
